import { render, staticRenderFns } from "./GoodsDialog.vue?vue&type=template&id=044c477a&scoped=true"
import script from "./GoodsDialog.vue?vue&type=script&lang=js"
export * from "./GoodsDialog.vue?vue&type=script&lang=js"
import style0 from "./GoodsDialog.vue?vue&type=style&index=0&id=044c477a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c477a",
  null
  
)

export default component.exports